import { ComponentsOverrides, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

import borders from "@/themes/base/borders";
import boxShadows from "@/themes/base/boxShadows";
import colors from "@/themes/base/colors";
import boxShadow from "@/themes/functions/boxShadow";
import pxToRem from "@/themes/functions/pxToRem";

const { grey, white, black, dark } = colors;
const { borderRadius, borderWidth } = borders;
const { sliderBoxShadow } = boxShadows;

interface ISlider {
  styleOverrides: ComponentsOverrides<Theme>["MuiSlider"];
}

const slider: ISlider = {
  styleOverrides: {
    root: {
      width: "100%",

      "& .MuiSlider-active, & .Mui-focusVisible": {
        boxShadow: "none !important",
      },

      "& .MuiSlider-valueLabel": {
        color: black.main,
      },
    } as CSSObject,

    rail: {
      height: pxToRem(2),
      background: grey![200],
      borderRadius: borderRadius.sm,
      opacity: 1,
    } as CSSObject,

    track: {
      background: dark.main,
      height: pxToRem(2),
      position: "relative",
      border: "none",
      borderRadius: borderRadius.lg,
      zIndex: 1,
    } as CSSObject,

    thumb: {
      width: pxToRem(14),
      height: pxToRem(14),
      backgroundColor: white.main,
      zIndex: 10,
      boxShadow: sliderBoxShadow.thumb,
      border: `${borderWidth[1]} solid ${dark.main}`,
      transition: "all 200ms linear",

      "&:hover": {
        boxShadow: "none",
      },

      "&:active": {
        transform: "translate(-50%, -50%) scale(1.4)",
      },

      "&.Mui-active": {
        boxShadow: boxShadow([0, 0], [0, 14], dark.main, 0.16),
      },
    } as CSSObject,
  },
};

export default slider;
